import { animate, state, style, transition, trigger } from '@angular/animations';

const progressFunction = '200ms ease-out';
export const NotificationAnimation = trigger('notificationAnimation', [
  state('void', style({ opacity: 0, marginLeft: '100%' })),
  state('*', style({ opacity: 1, marginLeft: '0' })),
  transition('void => *', [animate(progressFunction)]),
  transition('* => void', [animate(progressFunction)])
]);
